<template>
  <!--  -->
  <FsDialog v-model="select_template_popup" :close-modal="false" :class-name="popupClassName">
    <template #header>
      <div class="header_box">
        <div class="header_left">
          Create topology diagram
          <!-- <FsTooltip placement="top" trigger="hover"
						content="When you create a project using a template, you cannot edit the topology structure.">
						<span class="iconfont icon-info-xinxi"></span>
					</FsTooltip> -->
        </div>
        <FsInput new-regular v-model="search" search placeholder="Search" clearable />
      </div>
    </template>
    <div class="loading_box" v-show="dataLoading" v-loading="dataLoading"></div>
    <div class="ctn_box" v-if="!dataLoading && tabList.length">
      <div class="side_box">
        <div
          class="side_item"
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ _active: tabActive === item.typeId }"
          @click="tabActive = item.typeId"
        >
          <span>{{ item.typeName }}</span>
        </div>
      </div>

      <div class="template_box" v-show="!search" v-loading="loading">
        <div
          class="template_item template_item_create"
          @click.stop="
            handleTemplateClick({
              description: '',
              id: 0,
              name: '',
              picUrl: '',
            })
          "
        >
          <div class="topology_box">
            <span class="iconfont icon-fs_2020111802icon"></span>
          </div>
          <div class="template_info">
            <h4 title="Custom Solution">Custom Solution</h4>
            <p
              title="Create a project from scratch without a template. Customize the network architecture, configurations, and components to fit your needs."
            >
              Create a project from scratch without a template. Customize the network architecture, configurations, and
              components to fit your needs.
            </p>
          </div>
        </div>
        <div
          class="template_item template_item_exist"
          v-for="item in filterList"
          :key="item.id"
          @click.stop="handleTemplateClick(item)"
        >
          <!-- <FsTooltip placement="bottom" :closeDelay="0" :teleport="false" :offsetY="9" :popper-content-style="{
						padding: '8px 12px',
						color: '#fff',
						lineHeight: '22px',
						backgroundColor: '#707070',
					}" arrow-back-color="#707070">
						<div class="topology_box" :style="{ backgroundImage: `url(${item.picUrl})` }">
							<FsButton type="red" size="small">Create</FsButton>
						</div>

						<template #content>
							<div class="trigger_content">
								<h4>{{ item.name }}</h4>
								<p>{{ item.description }}</p>
							</div>
						</template>
					</FsTooltip> -->
          <div class="topology_box" :style="{ backgroundImage: `url(${item.picUrl})` }">
            <FsButton type="red" size="small">Create</FsButton>
          </div>
          <div class="template_info">
            <h4 :title="item.name">{{ item.name }}</h4>
            <p :title="item.description">{{ item.description }}</p>
          </div>
        </div>
      </div>

      <div class="template_box" v-show="search && filterList?.length" v-loading="loading">
        <!-- <div
          class="template_item template_item_create"
          @click.stop="
            handleTemplateClick({
              description: '',
              id: 0,
              name: '',
              picUrl: '',
            })
          "
        >
          <div class="topology_box">
            <span class="iconfont icon-fs_2020111802icon"></span>
          </div>
          <div class="template_info">
            <h4 title="Custom Solution">Custom Solution</h4>
            <p
              title="Create a project from scratch without a template. Customize the network architecture, configurations, and components to fit your needs."
            >
              Create a project from scratch without a template. Customize the network architecture, configurations, and
              components to fit your needs.
            </p>
          </div>
        </div> -->
        <div
          class="template_item template_item_exist"
          v-for="item in filterList"
          :key="item.id"
          @click.stop="handleTemplateClick(item)"
        >
          <div class="topology_box" :style="{ backgroundImage: `url(${item.picUrl})` }">
            <FsButton type="red" size="small">Create</FsButton>
          </div>
          <div class="template_info">
            <h4 :title="item.name">{{ item.name }}</h4>
            <p :title="item.description">{{ item.description }}</p>
          </div>
        </div>
      </div>

      <div class="no_data_box" v-show="search && !filterList?.length">
        <img src="https://resource.fs.com/mall/generalImg/20250509122213vjgf4w.svg" alt="" />
        <p class="no_data_title">Sorry, No Results Found for "{{ search }}"</p>
        <p class="no_data_info">You can use custom template by clicking the button</p>
        <FsButton
          type="red"
          size="mediumSmall"
          @click="
            handleTemplateClick({
              description: '',
              id: 0,
              name: '',
              picUrl: '',
            })
          "
          :loading="loading"
        >
          Use Custom Template
        </FsButton>
      </div>
    </div>
  </FsDialog>
</template>

<script setup lang="ts">
import { computed, ref, reactive, onMounted, watch } from 'vue'
import { FsDialog, FsButton, FsTooltip, FsInput } from 'fs-design'
import { useHeaderStore } from '@/store/header'
import { useProjectStore } from '@/store/project'
import { storeToRefs } from 'pinia'
import { getTemplatePopupList, getProjectDetail, createProject, bindTemplate } from '@/api/modules/project'
import { useRouter } from 'vue-router'
import { useProductSelectionStore } from '@/store/productSelection'
import { trackEvent } from '@/utils/analytics'
import { debounce } from 'lodash-es'
// 定义模板项的类型
interface TemplateItem {
  description: string
  id: number
  name: string
  picUrl: string
}

// 定义每个类型项的类型
interface TypeItem {
  templateList: TemplateItem[]
  typeId: number
  typeName: string
}

const productSelectionStore = useProductSelectionStore()
const projectStore = useProjectStore()
const headerStore = useHeaderStore()
const router = useRouter()
const search = ref<string>('')
const loading = ref<boolean>(false)
const dataLoading = ref<boolean>(false)
const { select_template_popup } = storeToRefs(headerStore)
const emits = defineEmits(['update:open', 'action'])

const tabActive = ref<number>(0)
const tabList = ref<TypeItem[]>([])

const popupClassName = computed(() => {
  if (tabList.value.length && tabList.value[0].templateList?.length > 5) {
    return 'select_template_popup select_template_popup_max'
  } else {
    return 'select_template_popup'
  }
})
const handleTemplateClick = (item: TemplateItem) => {
  if (localStorage.getItem('currentProjectId')) {
    loading.value = true
    localStorage.setItem('currentTemplateTypeId', tabActive.value.toString())
    bindTemplate({
      projectId: localStorage.getItem('currentProjectId'),
      templateId: item.id,
      tempTypeId: tabActive.value,
    })
      .then(res => {
        trackEvent({
          eventCategory: 'des_project_create',
          eventAction: 'create_success',
          eventLabel: tabList.value.filter(v => v.typeId === tabActive.value)[0]?.typeName,
          creation_method: item.id ? 'template' : 'custom',
          template_id: item.id,
        })
        loading.value = false

        projectStore.setCurrentTemplateId(item.id)
        headerStore.hideSelectTemplatePopup()
        search.value = ''
        projectStore.getAllProjectList()
        router.replace('/design-center')
        productSelectionStore.clearSelectedProductIds()
      })
      .catch(error => {
        loading.value = false
      })
    // getProjectDetail({ id: localStorage.getItem('currentProjectId') })
    // 	.then(res => {
    // 		if (res.code === 200) {
    // 			const data = Object.assign({}, res.data)
    // 			createProject({
    // 				...data,
    // 				templateId: item.id,
    // 				isCustomized: item.id ? 0 : 1,
    // 			})
    // 				.then(r => {
    // 					loading.value = false
    // 					if (r.code === 200) {
    // 						projectStore.setCurrentTemplateId(item.id)
    // 						headerStore.hideSelectTemplatePopup()
    // 						search.value = ''
    // 						projectStore.getAllProjectList()
    // 						router.replace('/design-center')
    // 					}
    // 				})
    // 				.catch(e => {
    // 					loading.value = false
    // 				})
    // 		}
    // 		return
    // 	})
    // 	.catch(err => {
    // 		loading.value = false
    // 	})
  }
}

const debouncedTrack = debounce(() => {
  trackEvent({
    eventCategory: 'design_template',
    eventAction: 'template_operate',
    eventLabel: search.value,
  })
}, 1000)

const filterList = computed(() => {
  if (!search.value.trim()) {
    return tabList.value.filter((item: any) => item.typeId === tabActive.value)[0]?.templateList || []
  }
  debouncedTrack()
  const allTemplateList = tabList.value.flatMap((item: any) => item.templateList)
  return allTemplateList.filter((item: any) =>
    item.name.toLocaleLowerCase().includes(search.value.trim().toLocaleLowerCase())
  )
})
// onMounted(() => {
// 	dataLoading.value = true
// 	getTemplatePopupList()
// 		.then(res => {
// 			if (Array.isArray(res.data) && res.data.length > 0) {
// 				tabList.value = res.data
// 				tabActive.value = res.data[0].typeId
// 			} else {
// 				console.warn('No template data returned from the API')
// 			}
// 		})
// 		.catch(error => {
// 			console.error('Failed to fetch template list:', error)
// 		})
// 		.finally(() => {
// 			dataLoading.value = false
// 		})
// })

watch(
  select_template_popup,
  (newVal, oldVal) => {
    console.log(12312312313, '12312312312')
    if (newVal) {
      dataLoading.value = true
      getTemplatePopupList()
        .then(res => {
          if (Array.isArray(res.data) && res.data.length > 0) {
            tabList.value = res.data
            tabActive.value = res.data[0].typeId
            console.log(tabActive, 'tabActive')
          } else {
            console.warn('No template data returned from the API')
          }
        })
        .catch(error => {
          console.error('Failed to fetch template list:', error)
        })
        .finally(() => {
          dataLoading.value = false
        })
    }
  },
  { immediate: true }
)
</script>

<style lang="scss">
.fs-dialog {
  > .select_template_popup {
    width: calc(100% - 128px) !important;
    max-width: 1200px !important;

    &.select_template_popup_max {
      //   height: calc(100% - 128px);
    }
  }

  .select_template_popup {
    .fs-dialog__content--box {
      padding: 0;
      flex: 1 1 auto;
      min-height: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
.header_box {
  padding: 19px 40px 19px 20px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid #eee;

  .header_left {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 28px;
    font-weight: 600;
    @include font18;
    color: #19191a;
  }

  :deep(.fs-input) {
    width: 580px;
  }

  .iconfont {
    display: inline-block;
    width: 16px;
    height: 16px;
    font-size: 16px;
    line-height: 1;
    color: #707070;
    font-weight: 400;
    margin-left: 4px;
  }

  :deep(.fs-input) {
    &.is-focus {
      .fs-input__wrapper {
        border-color: #f6f6f8;
        background: #f6f6f8;
      }
    }

    .fs-input__wrapper {
      border-color: #f6f6f8;
      background: #f6f6f8;
    }
  }
}

.loading_box {
  height: 300px;
  position: relative;
}

.ctn_box {
  display: flex;
  align-items: stretch;
  flex-direction: row;
  height: auto;
  max-height: 568px;
  overflow: auto;
  width: 100%;
}

.side_box {
  width: 240px;
  overflow-y: auto;
  flex-shrink: 0;
  background: #f7f7f7;
  padding: 32px 0 32px 20px;
  position: sticky;
  top: 0;

  .side_item {
    display: flex;
    align-items: center;

    padding: 10px 20px;

    border-radius: 4px 0 0 4px;
    cursor: pointer;
    position: relative;

    &:hover {
      background: #fff;
    }

    &._active {
      background: #fff;

      span {
        &:after {
          @include redUnderline();
          opacity: 1;
        }
      }
    }

    span {
      @include font14;
      color: #19191a;
      padding-bottom: 4px;
      position: relative;
    }
  }
}

.trigger_content {
  h4 {
    @include font13;
    margin-bottom: 4px;
    word-break: break-word;
    white-space: normal;
  }

  p {
    @include font12;
    word-break: break-word;
    white-space: normal;
  }
}

.template_box {
  align-items: stretch;
  flex-wrap: wrap;
  padding: 32px 40px 16px 40px;
  display: flex;
  height: 100%;
  flex: 1 1 auto;
  .template_item {
    margin-bottom: 24px;
    cursor: pointer;
    width: calc((100% - 40px) / 3);
    margin-right: 20px;
    flex-shrink: 0;
    position: relative;

    &:nth-child(3n) {
      margin-right: 0;
    }

    :deep(.fs-tooltip) {
      width: 100%;
      margin-bottom: 16px;
    }

    &.template_item_create {
      .topology_box {
        background: #fafafa;
      }
    }

    &.template_item_exist {
      &:hover {
        .topology_box {
          :deep(.fs-button) {
            display: inline-flex;
          }
        }
      }
    }

    &:hover {
      .topology_box {
        :deep(.fs-button) {
          display: inline-flex;
        }

        &:after {
          opacity: 0.04;
        }
      }

      .template_info {
        h4 {
          text-decoration: underline;
        }
      }
    }
  }

  .topology_box {
    width: 100%;
    height: 158px;
    position: relative;
    margin-bottom: 16px;
    align-items: center;
    justify-content: center;
    display: flex;
    background: #fafafa;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #eeeeee;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    &:after {
      display: block;
      content: ' ';
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      position: absolute;
      background-color: #19191a;
      opacity: 0;
      transition: all 0.3s;
      z-index: 1;
    }

    .iconfont {
      font-size: 20px;
      color: #707070;
    }

    :deep(.fs-button) {
      position: absolute;
      right: 8px;
      bottom: 8px;
      display: none;
      z-index: 2;
    }
  }

  .template_info {
    h4 {
      color: #19191a;
      @include font14;
      font-weight: 600;
      margin-bottom: 8px;
      @include textOverflow();
    }

    p {
      @include font12;
      color: #707070;
      @include textClampOverflow(2);
    }
  }
}

.no_data_box {
  padding: 68px 0 68px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;

  > img {
    display: inline-block;
    width: 120px;
    height: 69px;
  }

  .no_data_title {
    @include font14;
    font-weight: 600;
    color: #19191a;
    margin: 12px 0 4px 0;
  }

  .no_data_info {
    @include font12;
    color: #707070;
    margin-bottom: 16px;
  }

  :deep(.fs-button) {
    min-height: auto !important;
  }
}
</style>
